// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__YU1Dt","title":"AfterFrontImage_title__1QIM2"};